module.exports = __webpack_public_path__ + "static/media/google_web_light_rd_na.654158d1.svg";